import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import lodash from "lodash";
import { URL } from "../url";
//component
import AllowScreen from "../layout/layout_allow";
import { LoadingScreen } from "../../../component/loading";
import { isLoggedSelector } from "store/bailiff/auth/bailiff_auth.selector";
import { useClaimToken } from "hook/useToken";
// redux

const PrivateRoute = (props) => {
  // -------------------------- VAR --------------------------
  let location = useLocation();
  const element = props?.element;
  const require = props?.require;
  const { permissions } = useClaimToken();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const logged = useSelector(isLoggedSelector);

  const diff =
    require?.length > 0 ? lodash.difference(require, permissions) : [];
  const allow = diff?.length === 0 ? true : false;

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  if (logged === null) {
    return <LoadingScreen />;
  }
  if (logged === false) {
    return <Navigate to={URL.home} exact state={{ from: location }} replace />;
  }

  if (logged && !allow) {
    return <AllowScreen />;
  }
  return logged && allow ? (
    element
  ) : (
    <Navigate to={URL.home} exact state={{ from: location }} replace />
  );
};

export default PrivateRoute;
